import { repiAddContractFields } from '../../../store/repiStore';
import { string as YupString, object as YupObject, number as YupNumber } from '../../common/Yup';

export function addContractSchema(translate, productCategory) {
    const wrongInputMsg = translate("Search.Common.Validation.WrongInput");
    const mustBeNumber = translate("Repi.Error.Validation.DataCorrection.Number");
    const maxLengthMsg = translate("Repi.Error.Validation.MaxLength");

    if (productCategory === 1) {
        return YupObject().shape({
            [repiAddContractFields.contributorContractId]: YupString().required(wrongInputMsg).max(20, maxLengthMsg.replace("${length}", 20)),
            [repiAddContractFields.product]: YupNumber().integer().required(wrongInputMsg).typeError(mustBeNumber),
            [repiAddContractFields.currency]: YupString().required(wrongInputMsg),
            [repiAddContractFields.totalAmount]: YupNumber().typeError(mustBeNumber),
            [repiAddContractFields.remainingAmount]: YupNumber().required(wrongInputMsg).typeError(mustBeNumber),
            [repiAddContractFields.overdueAmount]: YupNumber().required(wrongInputMsg).typeError(mustBeNumber),
            [repiAddContractFields.dunningLevel]: YupNumber().integer().typeError(mustBeNumber),
            [repiAddContractFields.debtBuyerId]: YupString().max(25, maxLengthMsg.replace("${length}", 25))
        });
    }

    if (productCategory === 2) {
        return YupObject().shape({
            [repiAddContractFields.contributorContractId]: YupString().required(wrongInputMsg).max(20, maxLengthMsg.replace("${length}", 20)),
            [repiAddContractFields.product]: YupNumber().integer().required(wrongInputMsg).typeError(mustBeNumber),
            [repiAddContractFields.currency]: YupString().required(wrongInputMsg),
            [repiAddContractFields.totalAmount]: YupNumber().typeError(mustBeNumber),
            [repiAddContractFields.remainingAmount]: YupNumber().required(wrongInputMsg).typeError(mustBeNumber),
            [repiAddContractFields.overdueAmount]: YupNumber().required(wrongInputMsg).typeError(mustBeNumber),
            [repiAddContractFields.dunningLevel]: YupNumber().integer().typeError(mustBeNumber),
            [repiAddContractFields.debtBuyerId]: YupString().max(25, maxLengthMsg.replace("${length}", 25)),
            [repiAddContractFields.creditorId]: YupString().max(25, maxLengthMsg.replace("${length}", 25))
        });
    }

    if (productCategory === 3) {
        return YupObject().shape({
            [repiAddContractFields.contributorContractId]: YupString().required(wrongInputMsg).max(20, maxLengthMsg.replace("${length}", 20)),
            [repiAddContractFields.product]: YupNumber().integer().required(wrongInputMsg).typeError(mustBeNumber),
            [repiAddContractFields.currency]: YupString().required(wrongInputMsg),
            [repiAddContractFields.totalAmount]: YupNumber().typeError(mustBeNumber),
            [repiAddContractFields.overdueAmount]: YupNumber().required(wrongInputMsg).typeError(mustBeNumber),
            [repiAddContractFields.dunningLevel]: YupNumber().integer().typeError(mustBeNumber),
            [repiAddContractFields.debtBuyerId]: YupString().max(25, maxLengthMsg.replace("${length}", 25))
        });
    }

    return YupObject().shape({});
}